
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.214 9.005H4.785c-.16 0-.289-.151-.289-.337s.13-.335.289-.335l.465-.083V6l-.465-.087c-.16 0-.289-.15-.289-.336s.13-.336.289-.336H6.67c.058 0 .077-.024.085-.043-.002.01-.005.021-.005.052v3l.464.083c.16 0 .29.15.29.335s-.13.337-.29.337zM5.25 3h.735L6 2.997 6.015 3h.735v.705c0 .017.009.03.009.046s-.008.03-.009.046V4.5h-.725c-.01 0-.017.005-.025.005-.009 0-.017-.004-.025-.005H5.25v-.704c-.002-.016-.01-.029-.01-.045 0-.016.008-.03.01-.045V3zM6 0a6 6 0 100 12A6 6 0 006 0z"}})])
          )
        }
      }
    